import React, { useEffect, useState } from "react";
// import "antd/dist/antd.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { Sidebar } from "primereact/sidebar";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { getEstimatedDonation } from "../../apis/CycleApi";
import {
  getAmountofCurrentCycle,
  getDonationsCount,
  getTotalAmountofCurrentCycle,
  getYearlyDonations,
} from "../../apis/DonationApi";
import "./style.scss";
import icon from "../../images/groupd.png";
// import DonationForm from "../entities/Donation/donationForm";
import AllCycles from "./cycleTile/allCycles";
import PerCycleDonations from "./donationsTile/perCycleDonations";
import TotalDonations from "./donationsTile/totalDonations";

import {
  allCycleDates,
  countOfCycles,
  getLatestCycle,
  perCycleData,
  allCycles,
} from "../../apis/CycleApi";
import {
  currentCycleDeservants,
  // getDeservantCount,
  getCurrentCycleDeservantsCount,
  getCurrentCycleDistributorsCount,
} from "../../apis/CycleDistributorApi";
import { getDeservantCount } from "../../apis/DeservantApi";
import { countDistributors } from "../../apis/DistributorApi";
import CurrentCycleDeservantTile from "../dashboard/DeservantTile/currentcycledeservants";
import Deservant from "../entities/Deservant/Deservant";
import DeservantsChart from "./DeservantsChart/deservantsChart";
import CurrentCycleDistributors from "./distributorTile/currentCycleDistributors";
import TotalDistributors from "./distributorTile/totalDistributors";
import DonationsChart from "./DonationsChart/donationsChart";
import EstimatedDonationsChart from "./EstimatedDonationsChart/estimatedDonationsChart";
//import { allCycles } from "../../../apis/CycleApi";

const StepDashboard = (props) => {
  const [cycleYears, setCycleYears] = useState([]);
  const [cycleData, setCycleData] = useState([]);
  const [latestYear, setLatestYear] = useState();
  const [cycleDonations, setCycleDonations] = useState({});
  const [cycleDeservants, setCycleDeservants] = useState({});
  const [donationCount, setDonationCount] = useState([]);
  const [estimatedAmount, setEstimatedAmount] = useState();
  const [deservantsCount, setDeservantsCount] = useState([]);
  const [currentCycleAmount, setCurrentCycleAmount] = useState();
  const [cycleCount, setCycleCount] = useState([]);
  const [distributorCount, setDistributorCount] = useState([]);
  const [currentCycleDeservant, setCurrentCycleDeservant] = useState([]);
  const [currentCycleCount, setCurrentCycleCount] = useState([]);
  const [yearlyDonation, setYearlyDonation] = useState(0);
  const [currentCycleDeservantsVisible, setCurrentCycleDeservantsVisible] =
    useState(false);
  // const [donationFormVisible, setDonationFormVisible] = useState(false);
  const [currentCycleDonationsVisible, setCurrentCycleDonationsVisible] =
    useState(false);
  const [totalDonationsVisible, setTotalDonationsVisible] = useState(false);
  const [totalDeservantsVisible, setTotalDeservantsVisible] = useState(false);
  const [currentCycleDeservantCount, setCurrentCycleDeservantCount] = useState(
    []
  );
  const [currentCycleDistributorCount, setCurrentCycleDistributorCount] =
    useState([]);
  const [latestCycle, setLatestCycle] = useState([]);

  const [valuesForEdit, setValuesForEdit] = useState();
  const [cycleId, setCycleId] = useState(null);
  const [allCyclesVisible, setAllCyclesVisible] = useState(false);
  const [totalDistributorsVisible, setTotalDistributorsVisible] =
    useState(false);
  const [currentcycleDistributorsVisible, setCurrentCycleDistributorsVisible] =
    useState(false);
  const history = useHistory();

  const openTotalDonations = () => {
    setTotalDonationsVisible(true);
  };

  const openCurrentCycleDonations = () => {
    setValuesForEdit(null);
    setCurrentCycleDonationsVisible(true);
  };

  const hideDialogDonation = () => {
    setCurrentCycleDonationsVisible(false);
  };

  const hideDialogTotalDonations = () => {
    setTotalDonationsVisible(false);
  };
  const openTotalDeservants = () => {
    setTotalDeservantsVisible(true);
  };
  const hideDialogTotalDeservants = () => {
    setTotalDeservantsVisible(false);
  };
  const hideDialogTotalDistributors = () => {
    setTotalDistributorsVisible(false);
  };
  const hideDialogCurrentCycleDistributors = () => {
    setCurrentCycleDistributorsVisible(false);
  };

  const openCurrentCycleDeservants = () => {
    setValuesForEdit(null);
    setCurrentCycleDeservantsVisible(true);
  };
  const hideDialogCurrentCycleDeservants = () => {
    setCurrentCycleDeservantsVisible(false);
  };

  const hideDialogAllCycles = () => {
    setAllCyclesVisible(false);
  };

  const loadDonationCount = () => {
    getDonationsCount().then((res) => {
      if (res.status === 200) {
        setDonationCount(res.data);
      }
      
    });
    
  };

  const loadYearlyDonations = () => {
    const currentYear = new Date().getFullYear();
    getYearlyDonations(currentYear).then((res) => {
      if (res.status === 200) {
        setYearlyDonation(res.data);
      }
    });
  };

  const {
    formState: { errors },
  } = useForm();

  function CalculateEstimatedAmount() {
    var value = 0;
    if (estimatedAmount > currentCycleAmount) {
      value = estimatedAmount - currentCycleAmount;
      return value;
    } else if (estimatedAmount <= currentCycleAmount) {
      estimatedAmount = 0;
      return estimatedAmount;
    }
  }

  const loadCurrentCycleCount = () => {
    getTotalAmountofCurrentCycle().then((res) => {
      if (res.status === 200) {
        setCycleId(res.data);
        setCurrentCycleCount(res.data);
      }
    });
  };

  const EstAmount = () => {
    getEstimatedDonation().then((res) => {
      if (res.status === 200) {
        setEstimatedAmount(res.data);
        CalculateEstimatedAmount();
      }
    });
  };

  const loadDeservantsCount = () => {
    getDeservantCount().then((res) => {
      if (res.status === 200) {
        setDeservantsCount(res.data);
      }
    });
  };

  const loadCycleDates = () => {
    allCycleDates().then((res) => {
      if (res.status === 200) {
        setCycleYears(res.data);
        setLatestYear(Math.max(...res.data));
      }
    });
  };

  const currentCycleData = () => {
    getAmountofCurrentCycle().then((res) => {
      if (res.status === 200) {
        setCurrentCycleAmount(res.data);
      }
    });
  };
  const loadCountOfCycles = () => {
    countOfCycles().then((res) => {
      if (res.status === 200) {
        setCycleCount(res.data);
      }
    });
  };
  const loadCurrentCycleDeservantCount = () => {
    getCurrentCycleDeservantsCount().then((res) => {
      if (res.status === 200) {
        // setCycleId(res.data);
        setCurrentCycleDeservantCount(res.data);
      }
    });
  };
  const loadCurrentCycleDeservants = () => {
    currentCycleDeservants().then((res) => {
      if (res.status === 200) {
        setCycleId(res.data);
        setCurrentCycleDeservant(res.data);
      }
    });
  };

  const loadCycleCount = () => {
    countOfCycles().then((res) => {
      if (res.status === 200) {
        setCycleCount(res.data);
      }
    });
  };

  const loadDistributorCount = () => {
    countDistributors().then((res) => {
      if (res.status === 200) {
        setDistributorCount(res.data);
      }
    });
  };

  const loadCurrentCycleDistributorCount = () => {
    getCurrentCycleDistributorsCount().then((res) => {
      if (res.status === 200) {
        // setCycleId(res.data);
        setCurrentCycleDistributorCount(res.data);
      }
    });
  };

  const loadLatestCycle = () => {
    getLatestCycle().then((res) => {
      if (res.status === 200) {
        // setCycleId(res.data);
        setLatestCycle(res.data);
      }
    });
  };

  const dashboardApi = (e) => {
    perCycleData(e).then((res) => {
      console.log('API Response:', res);
      if (res.status === 200) {
        setCycleDonations(res.data.cycleDonations);
        setCycleDeservants(res.data.cycleDeservants)  
      }
    });
  };


  useEffect(() => {
    loadDonationCount();
    loadYearlyDonations();
    currentCycleData();
    loadCurrentCycleCount();
    loadCycleCount();
    EstAmount();
    loadDeservantsCount();
    loadCountOfCycles();
    loadCurrentCycleDeservantCount(cycleId);
    loadCurrentCycleDeservants();
    loadDistributorCount();
    loadCurrentCycleDistributorCount(cycleId);
    loadLatestCycle(cycleId);
    loadCycleDates();
  }, []);
  useEffect(() => {
    // Load donation amounts
    perCycleData().then((res) => {
      if (res.status === 200) {
        setCycleDonations(res.data.cycleDonations);
      }
    });

    // Load cycle metadata (includes statuses)
    allCycles().then((res) => {
      if (res.status === 200) {
        setCycleData(res.data);
      }
    });
  }, []);

  useEffect(() => {
    if (latestYear) {
      dashboardApi(latestYear);
    }
  }, [latestYear]);

 return (
  <React.Fragment>
    <div className="layout-main">
      <div
        className="
    flex 
    xl:flex-row
    w-[80vw] 
    max-[1250px]:w-[95vw] 
    lg:flex-wrap lg:w-[96vw] lg:ml-0 
    md:flex-col 
    max-[425px]:w-[70vw]
"

      >
        {/* Current Cycle Box */}
<div
  className="
    flex flex-col sm:flex-row items-center bg-white rounded-xl mt-3 
    w-full max-w-[480px] sm:ml-16 shadow h-auto sm:h-[116px]
    max-[425px]:ml-0
  "
>
  {/* Left section - Current Cycle */}
  <div className="bg-gradient-to-r from-sky-500 to-[#00D4C6] text-white rounded-t-xl sm:rounded-l-xl sm:rounded-tr-none w-full sm:w-[250px] flex flex-col justify-center items-start p-4 sm:h-full">
    <div className="w-full">
      <span className="text-2xl font-bold leading-6">Current cycle</span>
      <span className="text-lg font-medium opacity-90 block">RWP-April2025-2</span>
    </div>
  </div>

  {/* Right section - Collected and Required */}
  <div className="flex-1 w-full sm:w-auto flex justify-around sm:justify-evenly items-center px-4 py-2 sm:p-6">
    <div onClick={openCurrentCycleDonations} className="text-center cursor-pointer">
      <span className="block text-lg text-gray-500 font-semibold mb-1">Collected</span>
      <span className="text-xl font-bold text-gray-900">
        {currentCycleCount.toLocaleString()}
      </span>
    </div>

    <div className="hidden sm:block h-[50px] border-l border-gray-300"></div>

    <div className="text-center cursor-pointer">
      <span className="block text-lg text-gray-500 font-semibold mb-1">Required</span>
      <span className="text-xl font-bold text-gray-900">
        {(
          estimatedAmount > currentCycleCount
            ? estimatedAmount - currentCycleCount
            : 0
        ).toLocaleString()}
      </span>
    </div>
  </div>
</div>


        {/* Redesigned Total Donations Box */}
        <div
          className="
            flex flex-col sm:flex-row items-stretch bg-white rounded-2xl mt-4 
            w-full max-w-[550px] sm:ml-[50px] shadow-lg border border-gray-100
             h-auto sm:min-h-[140px] overflow-hidden
            max-[425px]:ml-0
          "
        >
          {/* Left section - Yearly Donations (Dynamic & Vibrant) */}
          <div 
            onClick={openTotalDonations}
            className="cursor-pointer bg-gradient-to-br from-[#0284c7] via-[#0ea5e9] to-[#00D4C6] 
                       text-white w-full sm:w-[260px] flex flex-col justify-center items-start p-6 
                       transition-all hover:opacity-95"
          >
            <div className="w-full">
              <span className="text-sm font-bold uppercase tracking-wider opacity-90 mb-1 block">Yearly Progress 2026</span>
              <span className="text-3xl font-black leading-tight">Collected</span>
              <span className="text-2xl font-bold mt-2 block whitespace-nowrap">Rs {yearlyDonation?.toLocaleString()}</span>
            </div>
          </div>

          {/* Right section - Metrics (Spacious & Clean) */}
          <div className="flex-1 w-full sm:w-auto flex flex-row items-center justify-between p-6 gap-6 bg-gray-50/50">
            <div className="flex flex-col text-left">
              <span className="text-sm font-bold text-gray-400 uppercase tracking-wide mb-1">Required</span>
              <span className="text-2xl font-black text-rose-500 leading-none">
                {Math.max(0, 20000000 - yearlyDonation).toLocaleString()}
              </span>
            </div>

            <div className="h-full border-l border-gray-200"></div>

            <div className="flex flex-col text-right pr-2">
              <span className="text-sm font-bold text-gray-400 uppercase tracking-wide mb-1">Goal</span>
              <span className="text-xl font-black text-sky-700 whitespace-nowrap leading-none">
                2.0 Crore
              </span>
            </div>
          </div>
        </div>

        {/* Total Deservants Box */}
        <div
          className="
            cursor-pointer flex items-center justify-between text-left 
            w-[480px] h-[120px] mt-3 ml-[50px] rounded-2xl shadow-md 
            border border-gray-200 px-4 py-3 gap-[2px]
            max-[425px]:ml-0 max-[425px]:w-[95%]
          "
          onClick={openTotalDeservants}
        >
          <div className="flex flex-col justify-center">
            <span className="text-gray-500 font-semibold text-md">
              Total Deservants
            </span>
            <span className="font-bold text-gray-900 text-2xl leading-tight">
              {deservantsCount}
            </span>
          </div>
          <div className="bg-gradient-to-r from-sky-500 to-[#00D4C6] w-[250px] h-full rounded-l-xl flex justify-center items-center">
            <img src={icon} alt="Deservants" className="w-16 h-16 object-contain" />
          </div>
        </div>
         
          

         
          <Sidebar
            visible={totalDonationsVisible}
            position="right"
            style={{ width: "80em" }}
            onHide={() => {
              setTotalDonationsVisible(false);
            }}
          >
            <TotalDonations hide={hideDialogTotalDonations} />
          </Sidebar>

          <Sidebar
            visible={currentCycleDonationsVisible}
            position="right"
            style={{ width: "80em" }}
            onHide={() => {
              setCurrentCycleDonationsVisible(false);
              setValuesForEdit(null);
            }}
          >
            <PerCycleDonations
              cycleDetail={cycleId ? cycleId : ""}
              hide={hideDialogDonation}
              editorValues={valuesForEdit ? valuesForEdit : null}
            />
          </Sidebar>

          <Sidebar
            visible={totalDeservantsVisible}
            position="right"
            style={{ width: "80em" }}
            onHide={() => {
              setTotalDeservantsVisible(false);
            }}
          >
            <Deservant type="dashboard" hide={hideDialogTotalDeservants} />
          </Sidebar>

          <Sidebar
            visible={currentCycleDeservantsVisible}
            position="right"
            style={{ width: "80em" }}
            onHide={() => {
              setCurrentCycleDeservantsVisible(false);
            }}
          >
            <CurrentCycleDeservantTile
              deservantCycle={cycleId ? cycleId : ""}
              hide={hideDialogCurrentCycleDeservants}
            />
          </Sidebar>

          <Sidebar
            visible={allCyclesVisible}
            position="right"
            style={{ width: "80em" }}
            onHide={() => {
              setAllCyclesVisible(false);
            }}
          >
            <AllCycles hide={hideDialogAllCycles} />
          </Sidebar>

          <Sidebar
            visible={totalDistributorsVisible}
            position="right"
            style={{ width: "80em" }}
            onHide={() => {
              setTotalDistributorsVisible(false);
            }}
          >
            <TotalDistributors hide={hideDialogTotalDistributors} />
          </Sidebar>

          <Sidebar
            visible={currentcycleDistributorsVisible}
            position="right"
            style={{ width: "80em" }}
            onHide={() => {
              setCurrentCycleDistributorsVisible(false);
            }}
          >
            <CurrentCycleDistributors
              hide={hideDialogCurrentCycleDistributors}
            />
          </Sidebar>
        </div>

        <div className="sep-chart">
          <div className="layout-dashborad-donation-graph">
            <div className="aligner-con-header">
              <span className="heading-graphics">Donations</span>
            </div>
            <div className="flex justify-content-center mb-1">
            <DonationsChart donations={cycleDonations} cycleData={cycleData} />


            </div>
            <div className="dashboradcard mb-0"></div>
          </div>

          <div className="layout-dashborad-deservant-graph">
            <div className="aligner-con-header">
              <span className="heading-graphics">Deservants</span>
            </div>
            <div className="flex justify-content-center mb-1">
              <DeservantsChart deservants={cycleDeservants} />
            </div>
            <div className="dashboradcard mb-0"></div>
          </div>
          <div className="layout-dashborad-est-donation-graph">
            <div className="aligner-con-header">
              <span className="heading-graphics">Estimated Donations</span>
            </div>
            <div className="flex justify-content-center mb-1">
              <EstimatedDonationsChart />
            </div>
            <div className="dashboradcard mb-0"></div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default StepDashboard;
